import React, { useState } from "react";
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import TooltipX from 'react-bootstrap/Tooltip';
import CloseButton from 'react-bootstrap/CloseButton';
import {
    getFirestore, collection, getDocs, query, where,
} from 'firebase/firestore';
import { spinner } from "../utils/Helper";
import apc from "../images/apc.png"
import userPic from "../images/user.png"

export default function About(props) {
    const { theme = 'dark' } = props;
    const isDark = theme === 'dark';

    const [showAboutContent, setShowAboutContent] = useState(false);
    const [showBoardModal, setShowBoardModal] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [selectedMember, setSelectedMember] = useState(null);
    const [items, setItems] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [sortOrder, setSortOrder] = useState("asc");

    // Hover states for different buttons
    const [hoverMeet, setHoverMeet] = useState(false);
    const [hoverCloseBoard, setHoverCloseBoard] = useState(false);
    const [hoverCloseProfile, setHoverCloseProfile] = useState(false);

    const handleCloseBoardModal = () => setShowBoardModal(false);

    const handleMeetTheBoard = async () => {
        setShowBoardModal(true);
        if (items.length > 0) return;

        spinner(true);
        try {
            const db = getFirestore();
            const ref = collection(db, "profiles");
            const q = query(ref, where('board', "==", true));
            const querySnapshot = await getDocs(q);
            const itemsList = querySnapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));
            setItems(itemsList);
        } catch (error) {
            console.error("Error fetching board members:", error);
        } finally {
            spinner(false);
        }
    };

    const handleShowModal = (member) => {
        setSelectedMember(member);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedMember(null);
    };

    const styles = {
        backdrop: isDark ? "bg-dark" : "bg-light docLight",
        canvas: isDark ? "bg-dark" : "bg-light",
        modal: isDark ? "bg-dark" : "bg-light",
        board: isDark ? "bg-dark" : "board",
        text: isDark ? "text-white" : "text-dark",
        subText: isDark ? "text-muted" : "text-muted",
        mainWrapper: isDark
            ? "bg-dark py-2 px-4 rounded-0 animated fadeIn my-1 "
            : "bg-light py-2 px-4 rounded-0 border border-light-subtle animated fadeIn my-1 ",
        itemCard: isDark ? "item-card cursor" : "item-card-light cursor p-2 mb-1 rounded border border-light-subtle d-flex justify-content-between align-items-center",
        hr: { borderColor: isDark ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)' }
    };

    const displayItems = items
        .filter(item =>
            (item.title?.toLowerCase() || "").includes(searchTerm.toLowerCase()) ||
            (item.name?.toLowerCase() || "").includes(searchTerm.toLowerCase())
        )
        .sort((a, b) => {
            const titleA = a.title || "";
            const titleB = b.title || "";
            const comparison = titleA.localeCompare(titleB);
            return sortOrder === "asc" ? comparison : -comparison;
        });

    return (
        <>
            <OverlayTrigger overlay={<TooltipX>Click here to learn more...</TooltipX>}>
                <span
                    className="orange cursor fw-bold fs-5"
                    style={{
                        textShadow: 'none',
                        marginLeft: '20px'
                    }}
                    onClick={() => setShowAboutContent(!showAboutContent)}
                >
                    {showAboutContent ? "Show less" : "Learn more about APC..."}
                </span>
            </OverlayTrigger>

            {showAboutContent && (
                <div className={styles.mainWrapper}>
                    <div className="row g-4 align-items-center m-0">
                        <div className="col-md-2 text-center">
                            <img
                                src={apc}
                                alt="APC"
                                style={{ maxHeight: '150px', width: 'auto' }}
                            />
                        </div>

                        <div className="col-md-4 ">
                            <h5 className="orange fw-bold mb-1" style={{ fontSize: '1.3rem', textShadow: 'none' }}>We Are:</h5>
                            <ul className={styles.subText} style={{ fontSize: '1.1rem', lineHeight: '1.5', paddingLeft: '1.5rem', textShadow: 'none' }}>
                                <li>Member Owned pro & social club</li>
                                <li>Private club with disparate membership</li>
                                <li>Located in a historic building</li>
                                <li>Affiliate of the National Press Club</li>
                            </ul>
                        </div>

                        <div className="col-md-4">
                            <h5 className="orange fw-bold mb-1" style={{ fontSize: '1.3rem', textShadow: 'none' }}>Benefits of Membership:</h5>
                            <ul className={styles.subText} style={{ fontSize: '1.1rem', lineHeight: '1.5', paddingLeft: '1.5rem', textShadow: 'none' }}>
                                <li>You are an owner of the club</li>
                                <li>Use facilities for personal/business events</li>
                                <li>Professional and entertaining activities</li>
                                <li>Pay less for drinks at the bar</li>
                            </ul>
                        </div>

                        <div className="col-md-2 text-center d-flex align-items-center justify-content-center">
                            <Button
                                variant="dark"
                                className="px-4 py-2 fw-bold"
                                onMouseEnter={() => setHoverMeet(true)}
                                onMouseLeave={() => setHoverMeet(false)}
                                style={{
                                    fontSize: '1.1rem',
                                    textShadow: 'none',
                                    backgroundColor: hoverMeet ? '#282828' : '#272626',
                                    color: hoverMeet ? '#e0981c' : '#83d6a2',
                                    border: 'none',
                                    borderRadius: '8px',
                                    outline: 'none',
                                    boxShadow: 'none',
                                    transition: 'all 0.3s ease'
                                }}
                                onClick={handleMeetTheBoard}
                            >
                                Board Members
                            </Button>
                        </div>
                    </div>
                </div>
            )}

            {/* Board Selection Modal */}
            <Modal
                show={showBoardModal}
                onHide={handleCloseBoardModal}
                size="lg"
                centered
                contentClassName={styles.modal}
                backdropClassName={styles.backdrop}
            >
                <Modal.Header className={isDark ? "border-0" : "border-bottom"}>
                    <Modal.Title>
                        <h3 className={isDark ? "orange animated rollIn" : "orange fw-bold animated fadeIn"} style={{ textShadow: 'none' }}>Board of Directors</h3>
                    </Modal.Title>
                    <CloseButton variant={isDark ? "white" : undefined} onClick={handleCloseBoardModal} />
                </Modal.Header>
                <Modal.Body className="padding custom-scrollbar">
                    <div className="search-container" style={{ textShadow: 'none' }}>
                        <div className="search-wrapper mb-3">
                            <svg className="search-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                                <circle cx="11" cy="11" r="8"></circle>
                                <line x1="21" x2="16.65" y2="16.65"></line>
                            </svg>
                            <input
                                className={isDark ? "search-input" : "form-control ps-5 border-light-subtle bg-light"}
                                placeholder="Search..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </div>

                        <div className="utility-bar">
                            <div className={isDark ? "result-count" : "small text-muted"}>
                                {searchTerm === "" ? `Total: ${items.length}` : `Found: ${displayItems.length}`}
                            </div>
                            <div className="sort-group">
                                <button className={`sort-btn ${sortOrder === 'asc' ? 'active' : ''}`} onClick={() => setSortOrder("asc")}>A-Z</button>
                                <button className={`sort-btn ${sortOrder === 'desc' ? 'active' : ''}`} onClick={() => setSortOrder("desc")}>Z-A</button>
                            </div>
                        </div>

                        <ul className="item-list p-0 mt-3 d-flex flex-wrap gap-2" style={{ textShadow: 'none', listStyle: 'none' }}>
                            {displayItems.map(item => (
                                <li
                                    key={item.id}
                                    className={styles.itemCard}
                                    style={{ minWidth: '280px', flex: '1 1 auto' }}
                                    onClick={() => handleShowModal(item)}
                                >
                                    <div>
                                        <strong className={isDark ? "item-title" : "text-primary small"} style={{ textShadow: 'none' }}>{item.title}</strong> &nbsp;&nbsp;
                                        <span className={isDark ? "item-name" : "text-dark fw-bold"} style={{ textShadow: 'none' }}>{item.name}</span>
                                    </div>
                                    <span className="item-chevron">&rsaquo;</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                </Modal.Body>
                <Modal.Footer className="border-0">
                    <Button
                        variant="warning"
                        className="px-4 py-2 fw-bold"
                        onMouseEnter={() => setHoverCloseBoard(true)}
                        onMouseLeave={() => setHoverCloseBoard(false)}
                        style={{
                            fontSize: '1rem',
                            textShadow: 'none',
                            backgroundColor: hoverCloseBoard ? '#272626' : '#ff8c00',
                            color: hoverCloseBoard ? '#ff8c00' : '#272626',
                            border: 'none',
                            borderRadius: '8px',
                            outline: 'none',
                            boxShadow: 'none',
                            transition: 'all 0.3s ease'
                        }}
                        onClick={handleCloseBoardModal}
                    >
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Profile Detail Modal */}
            <Modal show={showModal} onHide={handleCloseModal} centered
                contentClassName={styles.board}
                backdropClassName={styles.backdrop}>
                <Modal.Body className="padding">
                    {selectedMember && (
                        <div className={isDark ? "padding animated zoomIn" : "p-2 animated fadeIn"} style={{ textShadow: 'none' }}>
                            <div className="text-center mb-4">
                                {(selectedMember.filex || selectedMember.photo) ? (
                                    <img
                                        src={selectedMember.filex || selectedMember.photo}
                                        alt={selectedMember.name}
                                        className="modified animated fadeIn rounded-circle shadow-none"
                                        style={{ width: '150px', height: '150px', border: '3px solid #ff8c00', objectFit: 'cover' }}
                                    />
                                ) : (
                                    <img
                                        src={userPic}
                                        alt={selectedMember.name}
                                        className="modified animated fadeIn rounded-circle shadow-none"
                                        style={{ width: '150px', height: '150px', border: '3px solid #ff8c00', objectFit: 'cover' }}
                                    />
                                )}
                            </div>

                            <h2 className="orange text-center mb-1" style={{ textShadow: 'none' }}>{selectedMember.name}</h2>
                            <h5 className={isDark ? "white text-center italic mb-2" : "text-muted text-center italic mb-2"} style={{ textShadow: 'none' }}>{selectedMember.title}</h5>

                            {selectedMember.email && (
                                <div className="text-center mb-3">
                                    <a href={`mailto:${selectedMember.email}`} className="orange no-decoration hover-bright">
                                        <span className="small" style={{ textShadow: 'none' }}>{selectedMember.email}</span>
                                    </a>
                                </div>
                            )}

                            <hr style={styles.hr} />

                            <div className={isDark ? "white" : "text-dark"} style={{ fontSize: '1rem', lineHeight: '1.6', textShadow: 'none' }}>
                                {selectedMember.bio ? <p>{selectedMember.bio}</p> : <p className="text-muted text-center italic">No biography provided.</p>}
                            </div>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer className="border-0">
                    <Button
                        variant="warning"
                        className="px-4 py-2 fw-bold"
                        onMouseEnter={() => setHoverCloseProfile(true)}
                        onMouseLeave={() => setHoverCloseProfile(false)}
                        style={{
                            fontSize: '1rem',
                            textShadow: 'none',
                            backgroundColor: hoverCloseProfile ? 'black' : '#ff8c00',
                            color: hoverCloseProfile ? '#ff8c00' : 'black',
                            border: 'none',
                            borderRadius: '8px',
                            outline: 'none',
                            boxShadow: 'none',
                            transition: 'all 0.3s ease'
                        }}
                        onClick={handleCloseModal}
                    >
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}